import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useVocalCopy } from '../pitch-training/use-vocal-copy.js'
import { TheoryGlyphs } from '../theory-copy/theory-glyphs.js'
import styles from './melody-trainer-bleed.module.css'

/**
 * What a Level 1 take gets instead of a score when the tracker was hearing the speakers.
 *
 * A whole page rather than a banner on the feedback panel, because the two cannot appear together:
 * §12.2 says the take is NOT SCORED, and a percentage beside this sentence would be the melody
 * scoring itself while telling the singer that might be what happened. There is one action here,
 * and it is the retake.
 *
 * Spec: docs/superpowers/specs/2026-09-08-melody-plugin-design.md §12.2
 */

export interface MelodyTrainerBleedProps {
  onRetake: () => void
}

export const MelodyTrainerBleed: FC<MelodyTrainerBleedProps> = props => {
  const { onRetake } = props
  const bleed = useVocalCopy('vocal-bleed-detected')

  return (
    <section className={styles.bleed} aria-label="Take not scored">
      {bleed ? (
        <p className={styles.verdict}>
          <TheoryGlyphs>{bleed.body}</TheoryGlyphs>
        </p>
      ) : null}
      <Button variant="contained" color="primary" size="large" onClick={onRetake}>
        Try again
      </Button>
    </section>
  )
}
